module.exports = __webpack_public_path__ + "static/media/sura-provider.1b0a0777.svg";